import * as React from "react";
import Render from "source/app/presentation/Shared/Render";
import { WhenNoSearchResultsOptions } from "source/app/presentation/MainPanel/Dreams/Search/NoResults/WhenNoSearchResultsOptions";

export function WhenNoSearchResults({
    searchText,
    filteredData,
    style,
}: WhenNoSearchResultsOptions) {
    return (
        <Render id="dreamSearchError" when={searchText && !filteredData.length}>
            <div className={style}>No search results</div>
        </Render>
    );
}
